import { getCompanyByTin } from "./getCompanyByTin";

export async function deleteAvis(tin: string, reference_number: any, thisCompanies) {
    const company = await getCompanyByTin(tin, thisCompanies)
    if (company?.avises) {
      company.avises = company.avises.filter(avis => avis.reference_number !== reference_number);
    }
    await thisCompanies.update(company.id, { avises: company.avises });
  }